import { render } from "./PricesPage.vue?vue&type=template&id=097dfc9a"
import script from "./PricesPage.vue?vue&type=script&lang=js"
export * from "./PricesPage.vue?vue&type=script&lang=js"

import "./PricesPage.vue?vue&type=style&index=0&id=097dfc9a&lang=scss"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__